// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2Nj-z","content":"LayoutSettings_content__20wqk"};